import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { connect } from 'react-redux'
import {
  showModal,
  MODAL_CLIENT_CONSO_TRANSACTION,
  MODAL_CLIENT_SELECTION_TRANSFERT
} from 'redux/modules/modals'
import moment from 'moment'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import { calculsTransaction } from 'utils/PriceCalculHelpers'
import ButtonBase from '@material-ui/core/ButtonBase'
import AppBar from '@material-ui/core/AppBar'
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import TabUnselected from '@material-ui/icons/TabUnselected'
import ReceiptIcon from '@material-ui/icons/Receipt'
import SwapIcon from '@material-ui/icons/SwapHoriz'
import BarIcon from '@material-ui/icons/LocalBar'
import { getTableIcon } from 'utils/iconMatcher'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import WatchIcon from '@material-ui/icons/WatchLater'
import EuroIcon from '@material-ui/icons/EuroSymbol'
import GroupIcon from '@material-ui/icons/Group'

import * as Colors from '@material-ui/core/colors'
const runningColor = Colors.lightGreen['500']
const pauseColor = Colors.orange['400']
const propTypes = {
  classes: PropTypes.object.isRequired,
  transaction: PropTypes.object.isRequired,
  playTransaction: PropTypes.func.isRequired,
  pauseTransaction: PropTypes.func.isRequired,
  removeSideTable: PropTypes.func.isRequired,
  prepareForPayment: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired
}
const styles = theme => ({
  paperRoot: {
    flexGrow: 1,
    borderRadius: 5
  },
  button: {
    borderRadius: 5,
    margin: 5
  },
  playButton: {
    borderRadius: 5,
    margin: 5,
    backgroundColor: runningColor,
    '&:hover': {
      backgroundColor: Colors.lightGreen['700']
    }
  },
  appBar: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    minHeight: 52,
    color: 'white'
  },
  leftButton: {
    marginLeft: '0px !important',
    color: 'white'
  },
  title: {
    flex: 1,
    paddingLeft: 0,
    justifyContent: 'flex-start'
  },
  pauseButton: {
    borderRadius: 5,
    margin: 5,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  }
})
class SideSingleComponent extends Component {
  state = { elapsed: 0, total: '0.00', playersCount: 0, totalProducts: '0.00' }
  updateState = props => {
    if (props.transaction) {
      const totals = calculsTransaction(props.transaction)
      this.setState({
        elapsed: totals.elapsed,
        total: totals.total.toFixed(2),
        playersCount: totals.playersCount,
        totalProducts: totals.totalProducts.toFixed(2)
      })
    }
  }
  componentWillMount() {
    const { transaction } = this.props
    if (!transaction.pool.isPaused) {
      this.launchTimer()
    } else {
      this.updateState(this.props)
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
  componentWillReceiveProps(nextProps) {
    if (this.timer !== null && nextProps.transaction.pool.isPaused) {
      clearInterval(this.timer)
      this.timer = null
      this.updateState(nextProps)
    } else if (this.timer === null && !nextProps.transaction.pool.isPaused) {
      this.launchTimer()
    }
  }
  // function starting the timer
  launchTimer() {
    // Initial calculation for elapsed time
    this.tick()
    // Setup the timer to update every second the elapsed time
    this.timer = setInterval(this.tick, 1000)
  }
  // Update State function
  tick = () => {
    this.updateState(this.props)
  }

  // Click on Pause Button
  pause = () => {
    this.props.pauseTransaction(this.props.transaction)
  }

  // Click on Play Button
  play = () => {
    this.props.playTransaction(this.props.transaction)
  }

  // Close the SidedTable
  close = () => {
    this.props.removeSideTable(this.props.transaction)
  }
  titleClick = () => {
    this.props.history.push('/table/' + this.props.transaction.pool.table.key)
  }

  handleTransfertClick = e => {
    this.props.showModal(
      MODAL_CLIENT_SELECTION_TRANSFERT,
      this.props.transaction
    )
  }
  handleAddProductsClick = e => {
    this.props.showModal(MODAL_CLIENT_CONSO_TRANSACTION, this.props.transaction)
  }
  handlePaymentClick = e => {
    this.props.prepareForPayment(this.props.transaction)
  }

  render() {
    const { classes, transaction } = this.props
    const { pool } = transaction
    const { elapsed, total } = this.state
    const color = pool.isPaused ? pauseColor : runningColor
    const disabled = transaction.paymentReady
    return (
      <Paper
        elevation={3}
        className={classes.paperRoot}
        style={pool.isPaused ? styles.paperPaused : styles.paperRunning}>
        <AppBar elevation={1} className={classes.appBar} position="static">
          <Toolbar disableGutters className={classes.appBar}>
            <IconButton
              onClick={this.titleClick}
              className={classes.leftButton}>
              {getTableIcon(pool.table.type)}
            </IconButton>
            <ButtonBase
              disableRipple
              className={classes.title}
              onClick={this.titleClick}>
              <Typography variant="title" color="inherit" noWrap>
                {pool.table.name}
              </Typography>
              <GroupIcon style={{ marginLeft: 15 }} color="inherit" />
              <Typography variant="caption" color="inherit">
                {this.state.playersCount}
              </Typography>
            </ButtonBase>
            <IconButton onClick={this.close}>
              <TabUnselected style={{ color: 'white' }} color="inherit" />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid
          item
          container
          direction="row"
          justify="space-around"
          alignItems="center"
          spacing={0}>
          <Grid item xs={6}>
            <List style={{ paddingLeft: 10 }}>
              <ListItem
                button
                disableGutters
                onClick={transaction.pool.isPaused ? this.play : this.pause}>
                <ListItemIcon>
                  <WatchIcon style={{ color: color }} color="inherit" />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  style={{ color, fontSize: 15, padding: 0 }}
                  primary={moment(elapsed)
                    .utc()
                    .format('HH:mm:ss')}
                />
              </ListItem>
              {/* <ListItem disableGutters dense >
                  <ListItemIcon>
                    <BarIcon style={{color : color}} color="inherit" />
                  </ListItemIcon>
                  <ListItemText disableTypography style={{color, fontSize : 15, padding : 0}}
                    primary={this.state.totalProducts} />
                </ListItem> */}
            </List>
          </Grid>
          <Grid item xs={6}>
            <List style={{ paddingLeft: 10 }} dense disablePadding>
              <ListItem disableGutters dense>
                <ListItemIcon>
                  <EuroIcon style={{ color: color }} color="inherit" />
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  style={{ color, fontSize: 15, padding: 0 }}
                  primary={total.toString()}
                />
              </ListItem>
              {/* <ListItem disableGutters dense>
                  <ListItemIcon>
                    {(transaction.pool.alert) ? <NotifIcon style={{color : color}} color="inherit" />
                      : <NoNotifIcon style={{color : color}} color="inherit" />}
                  </ListItemIcon>
                  <ListItemText disableTypography style={{color, fontSize : 15, padding : 0}}
                    primary={(transaction.pool.alert)
                      ? moment(moment(transaction.pool.alert).diff(moment())).utc().format('HH:mm:ss') : '-'} />
                </ListItem> */}
            </List>
          </Grid>
        </Grid>
        <Grid
          item
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={0}
          wrap="nowrap">
          <Button
            disabled={
              !transaction.sale_id || !transaction.pool.id_sale_product_detail
            }
            className={classes.button}
            size="small"
            onClick={this.handlePaymentClick}
            variant="raised"
            color="primary">
            <ReceiptIcon color="inherit" />
          </Button>
          <Button
            disabled={
              disabled ||
              !transaction.sale_id ||
              !transaction.pool.id_sale_product_detail
            }
            onClick={this.handleTransfertClick}
            size="small"
            className={classes.button}
            variant="raised"
            color="primary">
            <SwapIcon color="inherit" />
          </Button>
          <Button
            disabled={
              disabled ||
              !transaction.sale_id ||
              !transaction.pool.id_sale_product_detail
            }
            className={classes.button}
            size="small"
            onClick={this.handleAddProductsClick}
            variant="raised"
            color="primary">
            <BarIcon color="inherit" />
          </Button>
        </Grid>
      </Paper>
    )
  }
}
const mapActionCreators = {
  showModal
}
SideSingleComponent.propTypes = propTypes
export default connect(state => state, mapActionCreators)(
  withStyles(styles)(withRouter(SideSingleComponent))
)



// WEBPACK FOOTER //
// ./src/routes/Home/components/SideSingleComponent.js